export default __webpack_public_path__ + "static/media/esdoc.0ce109dd.svg";